<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!------------------------------------ Table Content ------------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- privateNumber -->
        <td>
          <td-value copyToClipboard [value]="item?.number"></td-value>
        </td>

        <!-- smsCp -->
        <td>
          <span> {{ item?.smsCp | enumToText : SmsCpEnumValues }}</span>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <a
            (click)="onUpdate(item?.id)"
            class="btn btn-sm"
            [matTooltip]="'common.edit' | translate"
          >
            <i
              class="mdi mdi-pencil-outline mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-navyBlue"
            ></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-public-receive-keywords-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-public-receive-keywords-form>
</ng-container>

<!--------------------------------------- Audit ---------------------------------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------- help ---------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    menuTitle="publicReceiveKeywords"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
